import React, {Component} from 'react';
class UpgradeImg extends Component {
    constructor(props) {
        super(props);
        this.UpdateImage = this.UpdateImage.bind(this);
        this.ReadyStart = this.ReadyStart.bind(this);
        this.state = { readyToSwap: this.props.ready};
    }
    // react function taking in new props, fires initially and on props change.
    // used to listen for pageload.
    componentWillReceiveProps(newprops) {
        // if page is loaded we trigger update image after waiting 1 second to make sure DOM is finished. 
        if(newprops.ready){
            setTimeout(this.UpdateImage,1000);
           
        }
    }
    ReadyStart() {
        // create new image to load in background not on DOM.
        let NewImg = new Image();
        // set src of larger image aka upgrade prop
        NewImg.src = this.props.upgrade;
       // onload event of newimage triggers DOM manupulation to update to source of new image. 
        NewImg.onload = (e) => {
            document.getElementById(this.props.id).src = NewImg.src
        }
    }
    UpdateImage() {
        // trigger upgrade start function and update state to True. 
        this.ReadyStart();
        this.setState({readyToSwap: true})
}
    render() {
       
        return (
            <img 
            id={this.props.id} 
            src={this.props.srcImg} 
            alt={this.props.alt}
            className={this.props.class}
            ></img>
        )
    }
}
export default UpgradeImg;

